import APIClient from '@/shared/http/clients/api'

const resourceName = 'usuarios'
const APICore = process.env.APIBaseURLCore
/*
const Get = (countryId, config = {}) => APIClient.get(`${APIAccess}/${resourceName}`, config)
const GetLogged = (config = {}) => APIClient.get(`${APIAccess}/${resourceName}/logged`, config)
*/
const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const GetLogged = (config = {}) => APIClient.get(`${APICore}/${resourceName}/logged`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (document = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?document=${document}&page=${index}&size=${limit}`, config)
const GetAllName = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/kanbanUsers/?size=5000`, data, config)
const ResetPassword = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/password/recover`, data, config)
const ChangePassword = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/password`, data, config)

const AccountRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  GetLogged,
  Create,
  Update,
  Delete,
  Search,
  GetAllName,
  ResetPassword,
  ChangePassword
}

export default AccountRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/account.js